var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "esContentsNav" }, [
    _c(
      "ul",
      {
        staticClass: "esAccordionNav accordion",
        attrs: { "data-accordion": "", "data-allow-all-closed": "true" }
      },
      [
        _c("li", { staticClass: "esAccordionNav__item" }, [
          _c(
            "a",
            {
              staticClass: "esAccordionNav__item__title accordion-title",
              attrs: { href: _vm.mekajikiManageUrl + "?kajikiId=" + _vm.siteId }
            },
            [_c("i", { staticClass: "fi-home" }), _vm._v(" TOP")]
          )
        ]),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "esAccordionNav__item accordion-item is-active",
            attrs: { "data-accordion-item": "" }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "esAccordionNav__item esAccordionNav__subMenu accordion-content",
                attrs: { "data-tab-content": "" }
              },
              [
                _c(
                  "transition",
                  { attrs: { name: "loading-effect", mode: "out-in" } },
                  [
                    _vm.isLoadingCategory
                      ? _c(
                          "div",
                          { key: "loading", staticClass: "loading-category" },
                          [
                            _c("span", {
                              staticClass: "loading-category__icon fi-download"
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "loading-category__text" },
                              [_vm._v("読み込み中 ...")]
                            )
                          ]
                        )
                      : _c(
                          "ul",
                          { key: "category-list", staticClass: "no-bullet" },
                          [
                            _c(
                              "li",
                              {
                                directives: [
                                  {
                                    name: "click-document",
                                    rawName: "v-click-document",
                                    value: _vm.hideSubMenu,
                                    expression: "hideSubMenu"
                                  }
                                ],
                                staticClass:
                                  "esAccordionNav__subMenu__item accordion-item",
                                class: {
                                  "esAccordionNav__subMenu__item--selected":
                                    _vm.isNoCategorySelected
                                },
                                on: {
                                  click: function($event) {
                                    _vm.unSelectCategory()
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "esAccordionNav__subMenu__item__title accordion-title categoryContainer"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "categoryContainer__label"
                                      },
                                      [
                                        _vm._v(
                                          "すべて(" +
                                            _vm._s(
                                              _vm.categoryWhole.categoryName
                                            ) +
                                            ")\n                  (" +
                                            _vm._s(
                                              _vm.categoryWhole.contentCount
                                            ) +
                                            ")\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "categoryContainer__menu",
                                        class: {
                                          "categoryContainer__menu--selected": _vm.isCategoryWholeSelected()
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "categoryContainer__menu__button",
                                            attrs: { title: "メニュー" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.toggleWholeMenu(
                                                  $event
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "subMenuIcon fi-widget"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.isCategoryWholeMenu
                                          ? _c("contents-nav-menu", {
                                              staticClass: "contents-nav-menu",
                                              attrs: {
                                                id: "dropdown-menu-whole",
                                                val: _vm.subMenuData(
                                                  _vm.categoryWhole
                                                )
                                              },
                                              on: {
                                                "menu-selected":
                                                  _vm.menuSelected
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.categories, function(categoryData) {
                              return _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "click-document",
                                      rawName: "v-click-document",
                                      value: _vm.hideSubMenu,
                                      expression: "hideSubMenu"
                                    }
                                  ],
                                  staticClass:
                                    "esAccordionNav__subMenu__item accordion-item ",
                                  class: {
                                    "esAccordionNav__subMenu__item--selected": _vm.isCategorySelected(
                                      categoryData
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.selectCategory(categoryData)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "esAccordionNav__subMenu__item__title accordion-title categoryContainer"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "categoryContainer__label"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "categoryContainer__label__categoryName textOverflow"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  categoryData.categoryName
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "categoryContainer__label__contentCount"
                                            },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    categoryData.contentCount
                                                  ) +
                                                  ")"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "categoryContainer__menu",
                                          class: {
                                            "categoryContainer__menu--selected": _vm.isCategorySelected(
                                              categoryData
                                            )
                                          }
                                        },
                                        [
                                          categoryData.categoryId
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "categoryContainer__menu__button",
                                                  attrs: { title: "メニュー" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.toggleSubMenu(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "subMenuIcon fi-widget"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isCategoryWholeMenu &&
                                          _vm.isNavMenuVisible &&
                                          _vm.isCategorySelected(categoryData)
                                            ? _c("contents-nav-menu", {
                                                staticClass:
                                                  "contents-nav-menu",
                                                attrs: {
                                                  id:
                                                    "dropdown-menu-" +
                                                    categoryData.categoryId,
                                                  val: _vm.subMenuData(
                                                    categoryData
                                                  )
                                                },
                                                on: {
                                                  "menu-selected":
                                                    _vm.menuSelected
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                  ]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("li", { staticClass: "esAccordionNav__item" }, [
          _c(
            "a",
            {
              staticClass: "esAccordionNav__item__title accordion-title",
              attrs: {
                href:
                  _vm.mekajikiManageUrl +
                  "siteitemmanage?kajikiId=" +
                  _vm.siteId
              }
            },
            [_c("i", { staticClass: "fi-monitor" }), _vm._v(" サイト管理")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "esAccordionNav__item" }, [
          _c(
            "a",
            {
              staticClass: "esAccordionNav__item__title accordion-title",
              attrs: {
                href:
                  _vm.mekajikiManageUrl +
                  "buildingListManage?kajikiId=" +
                  _vm.siteId
              }
            },
            [_c("i", { staticClass: "fi-page" }), _vm._v(" 静的棟ページ")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "esAccordionNav__item" }, [
          _c(
            "a",
            {
              staticClass: "esAccordionNav__item__title accordion-title",
              attrs: {
                href: _vm.mekajikiManageUrl + "usestatus?kajikiId=" + _vm.siteId
              }
            },
            [_c("i", { staticClass: "fi-graph-bar" }), _vm._v(" 利用状況")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "esAccordionNav__item" }, [
          _c(
            "a",
            {
              staticClass: "esAccordionNav__item__title accordion-title",
              attrs: {
                href:
                  _vm.mekajikiManageUrl + "config/site?kajikiId=" + _vm.siteId
              }
            },
            [_c("i", { staticClass: "fi-widget" }), _vm._v(" 設定")]
          )
        ]),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "esAccordionNav__item" },
          [
            _c("help-link", { attrs: { action: "manageFaq" } }, [
              _c(
                "a",
                {
                  staticClass:
                    "esAccordionNav__item__title accordion-title esJs-openFaq",
                  attrs: { href: "javascript:;" }
                },
                [_c("i", { staticClass: "helpIcon" }), _vm._v(" ヘルプ")]
              )
            ])
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "esDataCapacity" }, [
      _vm._v(
        _vm._s(_vm._f("fileSize")(_vm.usedStorage)) +
          " / " +
          _vm._s(_vm._f("fileSize")(_vm.totalStorage))
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "esAccordionNav__item__title accordion-title navTitle" },
      [_c("i", { staticClass: "fi-page" }), _vm._v(" 記事作成")]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }